<!--  -->
<template>
    <div class='Conference_details'>
        <div class="details_box">
            <div class="title">
                {{ data.title }}
            </div>
            <div class="content" v-html="data.intro"></div>
            <div class="details_v_t">
                Video center
            </div>
            <div class="details_v_box">
                <div v-for="(item,index) in data.videoVdmList" :key="index" class="details_v_box_1" @click="onvido(item)">
                    <div class="v_box_1_1">
                        <img :src="item.photo" alt="">
                    </div>
                    <div class="v_box_1_2">
                        {{ item.speechZt }}
                    </div>
                    <div class="iconfont_box">
                        <p class="iconfont">&#xe63a;</p>
                    </div>
                  
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import "@/assets/css/About_ISFAL.less"
    export default {
        name: 'Conference_details',
        data() {
            //这里存放数据
            return {
                code: null,
                data:{}
            }
        },
        components: {},

        //方法集合
        methods: {
            onvido(item){
                this.$router.push('/Conference/video/'+item.code)
            },
            meetingdetail() {
                var _this = this;
                _this.$api.meetingdetail({
                    meetingCode: _this.code
                }).then(res => {
                    if (res.code == 200) {
                        console.log(res)
                        _this.data = res.data

                    } else {
                        _this.$message.error(res.msg);
                    }
                }).catch(function (error) {
                    _this.$message.error(error.msg);
                });
            },
        },
        created() {

        },
        mounted() {
            if (this.$route.params.code) {
                this.code = this.$route.params.code
                this.meetingdetail()
            }
        }
    }
</script>
<style scoped>

</style>